import React, { useState, useEffect, useRef } from 'react';
import createPlotlyComponent from 'react-plotly.js/factory';
import { Paper, Typography, Grid, Tooltip } from '@material-ui/core';
import { ThumbUpIcon, ErrorIcon, MoodBadIcon } from '../../components/ThemedIcons';
import { useDispatch, useSelector } from 'react-redux';
import { getClockedHoursTotal } from '../../util/helperFunctions';
import { getKpiDetails } from '../../redux/kpiDetails';
var Plotly = require('plotly.js/lib/core');
// Load in the trace types for pie
Plotly.register([require('plotly.js/lib/pie')]);
Plotly.register([require('plotly.js/lib/indicator')]);
Plotly.register([require('plotly.js/lib/bar')]);

const Plot = createPlotlyComponent(Plotly);


const Tip = ({ tip, ...props }) => {
  if (!tip) return '';
  return (
    <>
      {tip.indicator === 'GOOD' && (
        <Grid item xs={3} style={{ padding: '2px 4px' }}>
          <ThumbUpIcon color="success" />
        </Grid>
      )}
      {tip.indicator === 'BAD' && (
        <Grid item xs={3} style={{ padding: '2px 4px' }}>
          <MoodBadIcon color="error" />
        </Grid>
      )}
      {tip.indicator === 'warning' && (
        <Grid item xs={3} style={{ padding: '2px 4px' }}>
          <ErrorIcon color="warning" />
        </Grid>
      )}
      {tip.indicator === 'NEUTRAL' && (
        <Grid item xs={3} style={{ padding: '2px 4px' }}>
          <ErrorIcon color="info" />
        </Grid>
      )}
      <Grid item xs={9} >
        <Tooltip title={tip.additional}>
          <Typography style={{ whiteSpace: 'nowrap', fontSize: 12 }}>
            {tip.message}
          </Typography>
        </Tooltip>
      </Grid>
    </>
  );
};

const Kpi = () => {
  const billedHours = useSelector((s) => s.kpiDetails?.timecard?.billedHours);
  const desiredHours = useSelector((s) => s.kpiDetails?.timecard?.desiredHours);
  const utilization = useSelector((s) => s.kpiDetails?.timecard?.utilization);
  const timecard = useSelector((s) => s.timecard);
  const timecardId = timecard?.timecardId;
  const [graph, setGraph] = useState();
  const revision = useRef(0);

  const dispatch = useDispatch();

  useEffect(() => {
    if (timecardId) dispatch(getKpiDetails(timecardId));
  }, [timecardId, dispatch]);

  useEffect(() => {
    revision.current += 1;
    const unbilledHours = desiredHours - billedHours;
    setGraph({
      utilizationData: [
        {
          values: [
            billedHours || 0,
            (unbilledHours < 0 ? 0 : unbilledHours) || 0,
          ],
          marker: {
            colors: ['green', 'red'],
          },
          labels: ['Billed', 'Additional Desired'],
          texttemplate: ['', '', '', '', ''],
          name: '',
          hoverinfo: 'label+value+name',
          hole: 0.7,
          domain: { column: 0, row: 0 },
          type: 'pie',
        }
      ],
      utilizationLayout: {
        datarevision: revision.current,
        title: '',
        annotations: [
          {
            font: {
              size: utilization >= 1 ? 14 : 16,
            },
            showarrow: false,
            text:
              (Number.parseFloat(utilization || 0) * 100).toFixed(
                0
              ) + '%',
            x: 0.5,
            y: 0.5,
          }
        ],
        margin: { t: 0, b: 10, l: 0, r: 0 },
        paper_bgcolor: 'rgba(0,0,0,0)',
        plot_bgcolor: 'rgba(0,0,0,0)',
        height: 100,
        width: 150,
        showlegend: false,
        responsive: true,
        grid: { rows: 1, columns: 1 },
      },
    });
  }, [billedHours, desiredHours, utilization]);

  if (!graph || !timecard) return '';
  let timecardHoursPopulated = false;
  timecard?.workdays?.forEach((workday) => {
    if (getClockedHoursTotal(workday) > 0) timecardHoursPopulated = true;
  });
  const dataPopulated = timecard?.entries?.length > 0 || timecardHoursPopulated;

  return (
    <a target="_blank" style={{ textDecoration: "none" }}
      href="https://app.powerbi.com/groups/06838f76-8342-4342-8c56-a6e73418f2d2/reports/bd225240-3f1e-4b15-be1b-7d5c9dc17e63/8d7213b16e612428e563?experience=power-bi"
    >
      <Grid
        container component={Paper} style={{ position: 'relative', marginBottom: 10, padding: '10px 10px 14px 8px' }}
      >
        {dataPopulated ? (
          <>
            <Grid item xs={6}>
              <Grid
                container
                spacing={1}
                style={{
                  padding: 0,
                  width: 140,
                  alignItems: 'center'
                }}
              >
                <Tip tip={timecard.kpis?.tips?.[0]} />
                <Tip tip={timecard.kpis?.tips?.[1]} />
                <Tip tip={timecard.kpis?.tips?.[2]} />
                <Tip tip={timecard.kpis?.tips?.[3]} />
              </Grid>
            </Grid>
            <Grid
              item
              xs={6}
              style={{
                textAlign: 'center',
                borderLeft: '1px solid #d5d5d5',
                margin: '6px 0px 6px 0px',
              }}
            >
              <Grid container>
                <Grid item xs={12} style={{ paddingBottom: 2 }}>
                  <Plot data={graph.utilizationData} layout={graph.utilizationLayout} />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <div style={{ position: 'absolute', left: '0px', bottom: '2px', width: '100%', textAlign: 'center', color: '#a1a1a1', fontSize: '10px' }}>
                Click to open My Consultant Dashboard
              </div>
            </Grid>
          </>
        ) : (
          <Grid item xs={12} style={{ textAlign: 'center', padding: 40 }}>
            <Typography>Add time to begin to see insights</Typography>
          </Grid>
        )}
      </Grid>
    </a>
  );
};

export default Kpi;
